<template>
  <div v-if="!sessionActive">
    <button class="button button__login" @click="goToLogin">
      Вход в Казатель
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3 7.7C10.2074 7.79152 10.1338 7.90052 10.0836 8.02068C10.0334 8.14084 10.0076 8.26977 10.0076 8.4C10.0076 8.53022 10.0334 8.65915 10.0836 8.77931C10.1338 8.89948 10.2074 9.00848 10.3 9.1L12.2 11H3C2.45 11 2 11.45 2 12C2 12.55 2.45 13 3 13H12.2L10.3 14.9C10.2074 14.9915 10.1338 15.1005 10.0836 15.2207C10.0334 15.3408 10.0076 15.4698 10.0076 15.6C10.0076 15.7302 10.0334 15.8592 10.0836 15.9793C10.1338 16.0995 10.2074 16.2085 10.3 16.3C10.69 16.69 11.31 16.69 11.7 16.3L15.29 12.71C15.3827 12.6175 15.4563 12.5076 15.5064 12.3866C15.5566 12.2657 15.5824 12.136 15.5824 12.005C15.5824 11.874 15.5566 11.7443 15.5064 11.6234C15.4563 11.5024 15.3827 11.3925 15.29 11.3L11.7 7.7C11.6085 7.60736 11.4995 7.53381 11.3793 7.48361C11.2592 7.43341 11.1302 7.40756 11 7.40756C10.8698 7.40756 10.7408 7.43341 10.6207 7.48361C10.5005 7.53381 10.3915 7.60736 10.3 7.7ZM20 19H13C12.45 19 12 19.45 12 20C12 20.55 12.45 21 13 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H13C12.45 3 12 3.45 12 4C12 4.55 12.45 5 13 5H20V19Z" fill="white"/>
      </svg>
    </button>
  </div>

  <div class="profile__desktop-wrapper" v-if="sessionActive && windowWidth > 992">
    <router-link to="/personal-info">
      <img :src="getSrcAvatar" class="profile__image" alt="Личный кабинет" @error="handleImageError" />
    </router-link>
    <div class="profile__desktop_text-wrapper">
      <paragraph-size-large textWeight="600" v-if="$route.path === '/personal-info'"
        :textColor="'var(--background-red)'">
        {{ getStudent.firstName }}
      </paragraph-size-large>
      <paragraph-size-large textWeight="600" v-else :textColor="'var(--text-black)'" :hoverColor="'var(--background-red)'">
        {{ getStudent.firstName }}
      </paragraph-size-large>
    </div>
    <button class="profile__desktop_dropdown-button" @click="toggleDropdown">
      <svg v-if="!showDropdown" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_3988_46485)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7083 15.7083C12.5208 15.8958 12.2665 16.0011 12.0013 16.0011C11.7362 16.0011 11.4818 15.8958 11.2943 15.7083L5.63732 10.0513C5.54181 9.95907 5.46563 9.84873 5.41322 9.72672C5.36081 9.60472 5.33322 9.4735 5.33207 9.34072C5.33092 9.20794 5.35622 9.07626 5.4065 8.95337C5.45678 8.83047 5.53103 8.71882 5.62492 8.62492C5.71882 8.53103 5.83047 8.45678 5.95337 8.4065C6.07626 8.35622 6.20794 8.33092 6.34072 8.33207C6.4735 8.33322 6.60472 8.36081 6.72672 8.41322C6.84873 8.46563 6.95907 8.54181 7.05132 8.63732L12.0013 13.5873L16.9513 8.63732C17.1399 8.45516 17.3925 8.35437 17.6547 8.35665C17.9169 8.35892 18.1677 8.46409 18.3531 8.6495C18.5385 8.83491 18.6437 9.08572 18.646 9.34792C18.6483 9.61011 18.5475 9.86272 18.3653 10.0513L12.7083 15.7083Z" fill="#97989C"/>
        </g>
        <defs>
          <clipPath id="clip0_3988_46485">
            <rect width="24" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_3988_47038)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2956 8.29168C11.4831 8.10421 11.7374 7.99889 12.0026 7.99889C12.2678 7.99889 12.5221 8.10421 12.7096 8.29168L18.3666 13.9487C18.4621 14.0409 18.5383 14.1513 18.5907 14.2733C18.6431 14.3953 18.6707 14.5265 18.6718 14.6593C18.673 14.7921 18.6477 14.9237 18.5974 15.0466C18.5471 15.1695 18.4729 15.2812 18.379 15.3751C18.2851 15.469 18.1734 15.5432 18.0505 15.5935C17.9276 15.6438 17.796 15.6691 17.6632 15.6679C17.5304 15.6668 17.3992 15.6392 17.2772 15.5868C17.1552 15.5344 17.0448 15.4582 16.9526 15.3627L12.0026 10.4127L7.05259 15.3627C6.86398 15.5448 6.61138 15.6456 6.34919 15.6434C6.08699 15.6411 5.83618 15.5359 5.65077 15.3505C5.46536 15.1651 5.36019 14.9143 5.35791 14.6521C5.35563 14.3899 5.45643 14.1373 5.63859 13.9487L11.2956 8.29168Z" fill="#D8473A"/>
        </g>
        <defs>
          <clipPath id="clip0_3988_47038">
            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 24 24)"/>
          </clipPath>
        </defs>
      </svg>
    </button>

    <div v-if="showDropdown" class="profile__desktop_dropdown-menu">
      <div class="dropdown-menu__point" @click="pushToSettings()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#D8473A" stroke-width="2"/>
          <path d="M13.7635 2.152C13.3965 2 12.9305 2 11.9985 2C11.0665 2 10.6005 2 10.2335 2.152C9.99068 2.25251 9.77005 2.3999 9.58422 2.58572C9.39839 2.77155 9.25101 2.99218 9.1505 3.235C9.0585 3.458 9.0215 3.719 9.0075 4.098C9.00127 4.37199 8.9255 4.6399 8.78731 4.87657C8.64912 5.11324 8.45304 5.31091 8.2175 5.451C7.97839 5.58504 7.70914 5.6561 7.43503 5.6575C7.16092 5.6589 6.89096 5.59059 6.6505 5.459C6.3145 5.281 6.0715 5.183 5.8305 5.151C5.30482 5.08187 4.7732 5.22431 4.3525 5.547C4.0385 5.79 3.8045 6.193 3.3385 7C2.8725 7.807 2.6385 8.21 2.5875 8.605C2.55313 8.86545 2.57042 9.13012 2.63836 9.38389C2.70631 9.63767 2.82359 9.87556 2.9835 10.084C3.1315 10.276 3.3385 10.437 3.6595 10.639C4.1325 10.936 4.4365 11.442 4.4365 12C4.4365 12.558 4.1325 13.064 3.6595 13.36C3.3385 13.563 3.1305 13.724 2.9835 13.916C2.82359 14.1244 2.70631 14.3623 2.63836 14.6161C2.57042 14.8699 2.55313 15.1345 2.5875 15.395C2.6395 15.789 2.8725 16.193 3.3375 17C3.8045 17.807 4.0375 18.21 4.3525 18.453C4.56093 18.6129 4.79883 18.7302 5.0526 18.7981C5.30637 18.8661 5.57105 18.8834 5.8315 18.849C6.0715 18.817 6.3145 18.719 6.6505 18.541C6.89096 18.4094 7.16092 18.3411 7.43503 18.3425C7.70914 18.3439 7.97839 18.415 8.2175 18.549C8.7005 18.829 8.9875 19.344 9.0075 19.902C9.0215 20.282 9.0575 20.542 9.1505 20.765C9.25101 21.0078 9.39839 21.2284 9.58422 21.4143C9.77005 21.6001 9.99068 21.7475 10.2335 21.848C10.6005 22 11.0665 22 11.9985 22C12.9305 22 13.3965 22 13.7635 21.848C14.0063 21.7475 14.2269 21.6001 14.4128 21.4143C14.5986 21.2284 14.746 21.0078 14.8465 20.765C14.9385 20.542 14.9755 20.282 14.9895 19.902C15.0095 19.344 15.2965 18.828 15.7795 18.549C16.0186 18.415 16.2879 18.3439 16.562 18.3425C16.8361 18.3411 17.106 18.4094 17.3465 18.541C17.6825 18.719 17.9255 18.817 18.1655 18.849C18.4259 18.8834 18.6906 18.8661 18.9444 18.7981C19.1982 18.7302 19.4361 18.6129 19.6445 18.453C19.9595 18.211 20.1925 17.807 20.6585 17C21.1245 16.193 21.3585 15.79 21.4095 15.395C21.4439 15.1345 21.4266 14.8699 21.3586 14.6161C21.2907 14.3623 21.1734 14.1244 21.0135 13.916C20.8655 13.724 20.6585 13.563 20.3375 13.361C20.1032 13.2186 19.909 13.019 19.7731 12.7809C19.6372 12.5428 19.564 12.2741 19.5605 12C19.5605 11.442 19.8645 10.936 20.3375 10.64C20.6585 10.437 20.8665 10.276 21.0135 10.084C21.1734 9.87556 21.2907 9.63767 21.3586 9.38389C21.4266 9.13012 21.4439 8.86545 21.4095 8.605C21.3575 8.211 21.1245 7.807 20.6595 7C20.1925 6.193 19.9595 5.79 19.6445 5.547C19.4361 5.38709 19.1982 5.26981 18.9444 5.20187C18.6906 5.13392 18.4259 5.11664 18.1655 5.151C17.9255 5.183 17.6825 5.281 17.3455 5.459C17.1052 5.59042 16.8354 5.65862 16.5615 5.65722C16.2875 5.65582 16.0185 5.58486 15.7795 5.451C15.5439 5.31091 15.3479 5.11324 15.2097 4.87657C15.0715 4.6399 14.9957 4.37199 14.9895 4.098C14.9755 3.718 14.9395 3.458 14.8465 3.235C14.746 2.99218 14.5986 2.77155 14.4128 2.58572C14.2269 2.3999 14.0063 2.25251 13.7635 2.152Z" stroke="#D8473A" stroke-width="2"/>
        </svg>
        <paragraph-size-medium :textColor="'var(--text-black)'">Настройки</paragraph-size-medium>
      </div>
      <div class="dropdown-menu__point" @click="logout()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M11 12V4C11 3.71667 11.096 3.47933 11.288 3.288C11.48 3.09667 11.7173 3.00067 12 3C12.2833 3 12.521 3.096 12.713 3.288C12.905 3.48 13.0007 3.71733 13 4V12C13 12.2833 12.904 12.521 12.712 12.713C12.52 12.905 12.2827 13.0007 12 13C11.7167 13 11.4793 12.904 11.288 12.712C11.0967 12.52 11.0007 12.2827 11 12ZM12 21C10.7667 21 9.604 20.7627 8.512 20.288C7.42 19.8133 6.466 19.1673 5.65 18.35C4.83333 17.5333 4.18767 16.579 3.713 15.487C3.23833 14.395 3.00067 13.2327 3 12C3 10.85 3.21267 9.746 3.638 8.688C4.06333 7.63 4.659 6.684 5.425 5.85C5.60833 5.65 5.84167 5.55 6.125 5.55C6.40833 5.55 6.65 5.65 6.85 5.85C7.03333 6.03333 7.11667 6.26267 7.1 6.538C7.08333 6.81333 6.98333 7.059 6.8 7.275C6.23333 7.90833 5.79167 8.62933 5.475 9.438C5.15833 10.2467 5 11.1007 5 12C5 13.9333 5.68333 15.5833 7.05 16.95C8.41667 18.3167 10.0667 19 12 19C13.95 19 15.6043 18.3167 16.963 16.95C18.3217 15.5833 19.0007 13.9333 19 12C19 11.1 18.8417 10.2373 18.525 9.412C18.2083 8.58667 17.7583 7.85767 17.175 7.225C16.9917 7.025 16.8957 6.79167 16.887 6.525C16.8783 6.25833 16.966 6.03333 17.15 5.85C17.35 5.65 17.5917 5.55 17.875 5.55C18.1583 5.55 18.3917 5.65 18.575 5.85C19.3583 6.68333 19.9583 7.62933 20.375 8.688C20.7917 9.74667 21 10.8507 21 12C21 13.2333 20.7627 14.396 20.288 15.488C19.8133 16.58 19.1717 17.534 18.363 18.35C17.5543 19.1667 16.6043 19.8127 15.513 20.288C14.4217 20.7633 13.2507 21.0007 12 21Z" fill="#D8473A"/>
        </svg>
        <paragraph-size-medium :textColor="'var(--text-black)'">Выход</paragraph-size-medium>
      </div>
    </div>
  </div>

  <div class="profile__mobile-wrapper" v-if="sessionActive && windowWidth <= 992">
    <router-link to="/personal-info" class="link">
      <div class="profile__mobile-block">
        <div class="image-text__wrapper">
          <img :src="getSrcAvatar" class="profile__image" alt="Личный кабинет" @error="handleImageError" />
          <div class="text-info__wrapper">
            <paragraph-size-large textWeight="600" :textColor="'var(--text-black)'">
              {{ getStudent.firstName }}
            </paragraph-size-large>
            <paragraph-size-small :textColor="'var(--text-secondary)'">Перейти в профиль</paragraph-size-small>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7083 11.2932C15.8958 11.4807 16.0011 11.735 16.0011 12.0002C16.0011 12.2653 15.8958 12.5197 15.7083 12.7072L10.0513 18.3642C9.95907 18.4597 9.84873 18.5359 9.72672 18.5883C9.60472 18.6407 9.4735 18.6683 9.34072 18.6694C9.20794 18.6706 9.07626 18.6453 8.95337 18.595C8.83047 18.5447 8.71882 18.4705 8.62492 18.3766C8.53103 18.2827 8.45678 18.171 8.4065 18.0481C8.35622 17.9252 8.33092 17.7936 8.33207 17.6608C8.33322 17.528 8.36081 17.3968 8.41322 17.2748C8.46563 17.1528 8.54181 17.0424 8.63732 16.9502L13.5873 12.0002L8.63732 7.05018C8.45516 6.86158 8.35437 6.60898 8.35665 6.34678C8.35892 6.08458 8.46409 5.83377 8.6495 5.64836C8.83491 5.46295 9.08572 5.35778 9.34792 5.35551C9.61011 5.35323 9.86272 5.45402 10.0513 5.63618L15.7083 11.2932Z" fill="#97989C"/>
        </svg>
      </div>
    </router-link>

    <div class="profile__mobile_points-wrapper">
      <div class="mobile__point" @click="pushToSettings()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#D8473A" stroke-width="2"/>
          <path d="M13.7635 2.152C13.3965 2 12.9305 2 11.9985 2C11.0665 2 10.6005 2 10.2335 2.152C9.99068 2.25251 9.77005 2.3999 9.58422 2.58572C9.39839 2.77155 9.25101 2.99218 9.1505 3.235C9.0585 3.458 9.0215 3.719 9.0075 4.098C9.00127 4.37199 8.9255 4.6399 8.78731 4.87657C8.64912 5.11324 8.45304 5.31091 8.2175 5.451C7.97839 5.58504 7.70914 5.6561 7.43503 5.6575C7.16092 5.6589 6.89096 5.59059 6.6505 5.459C6.3145 5.281 6.0715 5.183 5.8305 5.151C5.30482 5.08187 4.7732 5.22431 4.3525 5.547C4.0385 5.79 3.8045 6.193 3.3385 7C2.8725 7.807 2.6385 8.21 2.5875 8.605C2.55313 8.86545 2.57042 9.13012 2.63836 9.38389C2.70631 9.63767 2.82359 9.87556 2.9835 10.084C3.1315 10.276 3.3385 10.437 3.6595 10.639C4.1325 10.936 4.4365 11.442 4.4365 12C4.4365 12.558 4.1325 13.064 3.6595 13.36C3.3385 13.563 3.1305 13.724 2.9835 13.916C2.82359 14.1244 2.70631 14.3623 2.63836 14.6161C2.57042 14.8699 2.55313 15.1345 2.5875 15.395C2.6395 15.789 2.8725 16.193 3.3375 17C3.8045 17.807 4.0375 18.21 4.3525 18.453C4.56093 18.6129 4.79883 18.7302 5.0526 18.7981C5.30637 18.8661 5.57105 18.8834 5.8315 18.849C6.0715 18.817 6.3145 18.719 6.6505 18.541C6.89096 18.4094 7.16092 18.3411 7.43503 18.3425C7.70914 18.3439 7.97839 18.415 8.2175 18.549C8.7005 18.829 8.9875 19.344 9.0075 19.902C9.0215 20.282 9.0575 20.542 9.1505 20.765C9.25101 21.0078 9.39839 21.2284 9.58422 21.4143C9.77005 21.6001 9.99068 21.7475 10.2335 21.848C10.6005 22 11.0665 22 11.9985 22C12.9305 22 13.3965 22 13.7635 21.848C14.0063 21.7475 14.2269 21.6001 14.4128 21.4143C14.5986 21.2284 14.746 21.0078 14.8465 20.765C14.9385 20.542 14.9755 20.282 14.9895 19.902C15.0095 19.344 15.2965 18.828 15.7795 18.549C16.0186 18.415 16.2879 18.3439 16.562 18.3425C16.8361 18.3411 17.106 18.4094 17.3465 18.541C17.6825 18.719 17.9255 18.817 18.1655 18.849C18.4259 18.8834 18.6906 18.8661 18.9444 18.7981C19.1982 18.7302 19.4361 18.6129 19.6445 18.453C19.9595 18.211 20.1925 17.807 20.6585 17C21.1245 16.193 21.3585 15.79 21.4095 15.395C21.4439 15.1345 21.4266 14.8699 21.3586 14.6161C21.2907 14.3623 21.1734 14.1244 21.0135 13.916C20.8655 13.724 20.6585 13.563 20.3375 13.361C20.1032 13.2186 19.909 13.019 19.7731 12.7809C19.6372 12.5428 19.564 12.2741 19.5605 12C19.5605 11.442 19.8645 10.936 20.3375 10.64C20.6585 10.437 20.8665 10.276 21.0135 10.084C21.1734 9.87556 21.2907 9.63767 21.3586 9.38389C21.4266 9.13012 21.4439 8.86545 21.4095 8.605C21.3575 8.211 21.1245 7.807 20.6595 7C20.1925 6.193 19.9595 5.79 19.6445 5.547C19.4361 5.38709 19.1982 5.26981 18.9444 5.20187C18.6906 5.13392 18.4259 5.11664 18.1655 5.151C17.9255 5.183 17.6825 5.281 17.3455 5.459C17.1052 5.59042 16.8354 5.65862 16.5615 5.65722C16.2875 5.65582 16.0185 5.58486 15.7795 5.451C15.5439 5.31091 15.3479 5.11324 15.2097 4.87657C15.0715 4.6399 14.9957 4.37199 14.9895 4.098C14.9755 3.718 14.9395 3.458 14.8465 3.235C14.746 2.99218 14.5986 2.77155 14.4128 2.58572C14.2269 2.3999 14.0063 2.25251 13.7635 2.152Z" stroke="#D8473A" stroke-width="2"/>
        </svg>
        <paragraph-size-medium :textColor="'var(--text-black)'">Настройки</paragraph-size-medium>
      </div>
      <div class="mobile__point" @click="logout()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M11 12V4C11 3.71667 11.096 3.47933 11.288 3.288C11.48 3.09667 11.7173 3.00067 12 3C12.2833 3 12.521 3.096 12.713 3.288C12.905 3.48 13.0007 3.71733 13 4V12C13 12.2833 12.904 12.521 12.712 12.713C12.52 12.905 12.2827 13.0007 12 13C11.7167 13 11.4793 12.904 11.288 12.712C11.0967 12.52 11.0007 12.2827 11 12ZM12 21C10.7667 21 9.604 20.7627 8.512 20.288C7.42 19.8133 6.466 19.1673 5.65 18.35C4.83333 17.5333 4.18767 16.579 3.713 15.487C3.23833 14.395 3.00067 13.2327 3 12C3 10.85 3.21267 9.746 3.638 8.688C4.06333 7.63 4.659 6.684 5.425 5.85C5.60833 5.65 5.84167 5.55 6.125 5.55C6.40833 5.55 6.65 5.65 6.85 5.85C7.03333 6.03333 7.11667 6.26267 7.1 6.538C7.08333 6.81333 6.98333 7.059 6.8 7.275C6.23333 7.90833 5.79167 8.62933 5.475 9.438C5.15833 10.2467 5 11.1007 5 12C5 13.9333 5.68333 15.5833 7.05 16.95C8.41667 18.3167 10.0667 19 12 19C13.95 19 15.6043 18.3167 16.963 16.95C18.3217 15.5833 19.0007 13.9333 19 12C19 11.1 18.8417 10.2373 18.525 9.412C18.2083 8.58667 17.7583 7.85767 17.175 7.225C16.9917 7.025 16.8957 6.79167 16.887 6.525C16.8783 6.25833 16.966 6.03333 17.15 5.85C17.35 5.65 17.5917 5.55 17.875 5.55C18.1583 5.55 18.3917 5.65 18.575 5.85C19.3583 6.68333 19.9583 7.62933 20.375 8.688C20.7917 9.74667 21 10.8507 21 12C21 13.2333 20.7627 14.396 20.288 15.488C19.8133 16.58 19.1717 17.534 18.363 18.35C17.5543 19.1667 16.6043 19.8127 15.513 20.288C14.4217 20.7633 13.2507 21.0007 12 21Z" fill="#D8473A"/>
        </svg>
        <paragraph-size-medium :textColor="'var(--text-black)'">Выход</paragraph-size-medium>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';

import ParagraphSizeLarge from '@/components/UI/texts/paragraphs/ParagraphSizeLarge.vue';
import ParagraphSizeMedium from '@/components/UI/texts/paragraphs/ParagraphSizeMedium.vue';
import ParagraphSizeSmall from '@/components/UI/texts/paragraphs/ParagraphSizeSmall.vue';

const { RegistrationClient } = require('@/generated/user/registration_grpc_web_pb.js');


export default {
  name: 'navbar-profile',

  components: {
    ParagraphSizeLarge,
    ParagraphSizeMedium,
    ParagraphSizeSmall
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      serviceURL: process.env.VUE_APP_REGISTRATION_SERVICE_URL,
      showPopupRegistration: false,
      loadingUser: true,
      showDropdown: false,
    };
  },

  computed: {
    ...mapGetters({
      getStudent: 'userData/getStudent',
      getSrcAvatar: 'userData/getSrcAvatar',
      sessionActive: 'authData/sessionActive',
    })
  },

  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    goToLogin(){
      this.$router.push('/login');
    },
    pushToSettings(){
      this.$router.push('/personal-info');
      this.toggleDropdown();
    },
    handleUpdateFromPopup() {},
    openPopupRegistration() {
      store.dispatch('popupAuth/openLoginPopup');
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    handleImageError(event) {
      event.target.src = require('@/assets/images/profile-image-plug.png');
    },
    ...mapActions({
      fetchUser: 'userData/fetchUser',
      createTokenState: 'authData/createState'
    }),

    async getUser() {
      try {
        await this.fetchUser();
      } catch (err) {
        console.log('Error in getUser:', err);
      }
    },
    async logout() {
      try {
        const registrationService = new RegistrationClient(this.serviceURL, null, null);
        const requestLogout = new proto.google.protobuf.Empty();
        const tokens = this.$getTokenInfo();
        const metadata = { 'token': tokens.accessToken.token };
        registrationService.logout(requestLogout, metadata, this.resultHandlerLogout);
      } catch (e) {
        // setAccessTokens({ token: "", lifetime: 0 }, { token: "", lifetime: 0 });
        // localStorage.tokenTimeCreated = 0;
        await this.createTokenState({
          accessToken: null,
          refreshToken: null,
          tokenTimeCreated: null,
          isRegistered: false
        });
        console.error('sendMail:', e, 'Ошибка выхода из сеанса пользователя');
      }
    },
    async resultHandlerLogout(err) {
      if (err) {
        let errMsg = null;
        let isAlert = false;
        switch (err.code) {
          case 2:
            errMsg = 'Сервис недоступен\n' + err.message;
            isAlert = true;
            break;
          case 14:
            errMsg = 'Сервис регистрации пользователей недоступен\n' + err.message;
            isAlert = true;
            break;
          default:
            errMsg = `Code: ${err.code}\n message: ${err.message}`;
          //isAlert = true;
        }
        console.error(errMsg);
        if (isAlert) {
          window.alert(errMsg);
        }
      } else {
        // setAccessTokens({ token: "", lifetime: 0 }, { token: "", lifetime: 0 });
        // localStorage.tokenTimeCreated = 0;
        await this.createTokenState({
          accessToken: null,
          refreshToken: null,
          tokenTimeCreated: null,
          isRegistered: false
        });
        this.$router.push("/login");
      }
    },
    async startSessionCheckInterval() {
      this.sessionCheckInterval = setInterval(async () => {
        /*await this.checkSession();*/
      }, 30000);
    },
    async stopSessionCheckInterval() {
      clearInterval(this.sessionCheckInterval);
    }
  },

  beforeDestroy() {
    this.stopSessionCheckInterval();
  },

  async created() {
    // this.startSessionCheckInterval();
  },

  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
  }
}
</script>

<style scoped>
.navbar-menu__photo {
  object-fit: cover;
}
.link {
  text-decoration: none;
}
.button__login{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0px 16px;
  height: 56px;
  border-radius: 4px;
  font-size: 20px;
  font-weight: 600;
  color: var(--background-brown);
  transition: .3s ease-in-out;
  z-index: 2;
  border: 2px solid var(--background-brown);
}
.button__login path{
  fill: var(--background-brown);
  transition: .3s ease-in-out;
}
.button__login:hover{
  background-color: var(--background-red);
  color: var(--white);
  transition: .3s ease-in-out;
  border: 2px solid var(--background-red);
}
.button__login:hover path{
  fill: var(--white);
  transition: .3s ease-in-out;
}
.profile__desktop-wrapper{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  position: relative;
}
.profile__image{
  border-radius: 100px;
  width: 52px;
  height: 52px;
  object-fit: cover;
}
.profile__desktop_text-wrapper{
  cursor: pointer;
}
.profile__desktop_dropdown-button{
  border: none;
  outline: none;
  background-color: transparent;
  width: 24px;
  height: 24px;
  margin-left: 8px;
}
.profile__desktop_dropdown-menu {
  position: absolute;
  width: 220px;
  top: 62px;
  right: -32px;
  background-color: #fff;
  border-radius: 8px;
  padding: 8px 16px;
  z-index: 100;
  box-shadow: 4px 0px 16px 0px rgba(74, 74, 74, 0.15);
}
.dropdown-menu__point{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
}
.dropdown-menu__point:hover{
  background-color: var(--background-light);
}
.profile__mobile-wrapper{
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
}

.profile__mobile-block{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--background-light);
  padding: 16px;
  border-radius: 8px;
}
.image-text__wrapper{
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.text-info__wrapper{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.mobile__point{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 12px 0px;
}

@media screen and (max-width: 992px) {
  .profile__image{
    width: 48px;
    height: 48px;
  }
}
</style>
